// src/services/savedSearchService.js
import { apiRequest } from "./apiService";

export const fetchSavedSearches = async () => {
  // no userId; backend uses session cookie
  return apiRequest("/saved-search", "GET");
};

export const saveSearch = async (searchDetails) => {
  return apiRequest("/saved-search", "POST", searchDetails);
};
